import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/LOGO.png'


const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "nav__container" }
const _hoisted_3 = { class: "nav__links" }
const _hoisted_4 = { class: "nav__links-list" }
const _hoisted_5 = { class: "nav__submenu-panel" }
const _hoisted_6 = { class: "nav__lang" }
const _hoisted_7 = { style: {} }
const _hoisted_8 = { style: {"height":"22px","width":"22px"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"display":"flex","align-items":"center","margin-left":"10px","width":"106px"} }
const _hoisted_11 = { style: {"width":"22px","height":"22px","margin-right":"5px"} }
const _hoisted_12 = ["src"]

import { useRoute } from "vue-router";
import { onMounted, reactive, ref, computed, watch } from "vue";
import { onBeforeRouteUpdate, onBeforeRouteLeave } from "vue-router";
import { useI18n } from "vue-i18n";
import ZH from "@/assets/img/CHN.png";
import EN from "@/assets/img/USA.png";
import ES from "@/assets/img/ESP.png";

export default /*@__PURE__*/_defineComponent({
  __name: 'TopNav',
  setup(__props) {

const route = useRoute();
const currentRoute = ref("");
const savedLang = localStorage.getItem("lang") || "en";
const langData = ref(savedLang);
const drawer = ref(false);
const langArr = reactive([
  { icon: ZH, nation: "zh" },
  { icon: EN, nation: "en" },
  { icon: ES, nation: "es" },
]);
const { locale } = useI18n();
const switchover = () => {
  localStorage.setItem("lang", langData.value);
  locale.value = langData.value;
};
const selectedIcon = computed(() => {
  const item = langArr.find((i) => i.nation === langData.value);
  return item ? item.icon : "";
});
const unfoldFn = () => {
  drawer.value = true;
};
onMounted(() => {
  currentRoute.value = route.path;
});
watch(
  () => route.path,
  (newPath) => {
    currentRoute.value = newPath;
  }
);
onBeforeRouteUpdate((to, from) => {
  drawer.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_menu, {
          "default-active": currentRoute.value,
          class: "el-menu-demo nav__menu",
          mode: "horizontal",
          "background-color": "rgb(14, 58, 106)",
          "text-color": "#FFFFFF",
          "active-text-color": "#68b04d",
          router: "",
          ellipsis: false
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "nav__logo" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_menu_item, { index: "/" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_1")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/about" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_2")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { class: "nav__submenu" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_3")) + " ", 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_menu_item, { index: "/policy-technology" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_4")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/carbon-market-tax" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_5")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/supply-chain-carbon-footprint" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_6")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/publicity-promotion" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_7")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/green-finance-investment" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_12")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/resource" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_8")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/support" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_9")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/news" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_10")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/join" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_11")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_select, {
                  modelValue: langData.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((langData).value = $event)),
                  placeholder: "Select",
                  style: {"width":"75px"},
                  teleported: false
                }, {
                  prefix: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: selectedIcon.value,
                          alt: "",
                          style: {"width":"100%","height":"100%"}
                        }, null, 8, _hoisted_9)
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langArr, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.nation,
                        value: item.nation,
                        disabled: item.disabled,
                        teleported: false,
                        onClick: switchover
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("img", {
                                src: item.icon,
                                alt: "",
                                style: {"width":"100%","height":"100%"}
                              }, null, 8, _hoisted_12)
                            ]),
                            _createTextVNode(" " + _toDisplayString(item.nation), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["value", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_component_el_menu_item, { style: {"display":"none"} })
            ])
          ]),
          _: 1,
          __: [2]
        }, 8, ["default-active"]),
        _createVNode(_component_el_icon, {
          color: "#ffffff",
          size: 40,
          class: "nav__toggle",
          onClick: unfoldFn
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Fold)
          ]),
          _: 1
        }),
        _createVNode(_component_el_drawer, {
          modelValue: drawer.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
          "show-close": true,
          size: "65%",
          "append-to-body": true,
          direction: "rtl",
          modal: true,
          "with-header": false,
          "destroy-on-close": true,
          "lock-scroll": false,
          "close-on-click-modal": true,
          style: {"background-color":"rgb(59, 58, 58)"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              "active-text-color": "#ffd04b",
              "background-color": "rgb(59, 58, 58)",
              class: "el-menu-vertical-demo drawer-nav",
              "default-active": currentRoute.value,
              "text-color": "#ffffff",
              router: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_1")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/about" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_2")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_sub_menu, { index: "committee" }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("TopNav.TopNav_3")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "/policy-technology" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_4")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/carbon-market-tax" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_5")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/supply-chain-carbon-footprint" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_6")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/publicity-promotion" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_7")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/green-finance-investment" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_12")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/resource" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_8")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/support" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_9")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/news" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_10")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/join" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("TopNav.TopNav_11")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["default-active"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "nav__spacer" }, null, -1))
  ], 64))
}
}

})